import { Box } from "@mui/material";
import Api from "api";
import CustomButton from "components/customButton";
import useUser from "hooks/useUser";
import { getMissionNameById } from "pages/dashboard/missions/missionsData";
import { DEFAULT_STORE_FORM, type IStoreForm } from "pages/missionThree";
import useMission from "pages/missionThree/hooks/useMission";
import getClusterItemsByColor from "pages/missionThree/utils/getClusterItemsByColor";
import IMGCelebrationOcta from "pages/registration/assets/images/celebration-octa.png";
import { useState } from "react";
import Confetti from "react-confetti-explosion";
import { useNavigate } from "react-router-dom";
import { UserActionType } from "reducers/userReducer";
import clearLocalStorage from "utils/clearlocalStorage";
import { getLocalStorage } from "utils/localStorage";
import trackEvent from "utils/mixpanelUtil";
import type { IBoard } from "../ClusterYourYearnings";

function Complete()
{
	const clientWidth = document.documentElement.clientWidth;
	const navigate = useNavigate();
	const [ isLoading, setIsLoading ] = useState<boolean>(false);
	const { state: userState, dispatch: userDispatch } = useUser();
	const missionContext = useMission();

	// Handles
	function onClickNextStep()
	{
		const storeForm = getLocalStorage<IStoreForm>("mission-three-form") || DEFAULT_STORE_FORM;
		const storeCluster: IBoard[] = getLocalStorage<IBoard[]>("mission-three-cluster") as IBoard[];

		const data = {
			...storeForm,
			mustHave: getClusterItemsByColor(storeCluster, "red").map((item) => item.title),
			clusters: storeCluster.filter((board) => board.id !== "__values__").map(({ items, title }) =>
			{
				return {
					title,
					items: items.map((boardItem) =>
					{
						return { title: boardItem.title, color: boardItem.color };
					})
				};
			})
		};

		// if (isLoading === true)
		// {
		// 	return;
		// }

		setIsLoading(true);

		Api.missions
			.setDataMissionThree(data)
			.then(() =>
			{
				trackEvent({
					eventName: "Mission Completed",
					userId: userState.user?.id,
					properties: { Mission: getMissionNameById(3) }
				});

				userDispatch(
					{
						type: UserActionType.COMPLETED_MISSION,
						payload: { completedMission: 3 }
					}
				);

				if (userState.user?.completedMission === 2)
				{
					setTimeout(() => missionContext.setStep(15), 0);
				}
				else
				{
					clearLocalStorage("mission-three");
					setTimeout(() => navigate("/dashboard"), 0);
				}

			})
			.catch((error: any) =>
			{
				console.error(error);
			})
			.finally(() =>
			{
				setIsLoading(false);
			});
	}

	return (
		<Box sx={{
			padding: { xl: "60px 32px 32px 32px", sm: "48px 32px 32px 32px", xs: "54px 32px 0 32px" },
			flexGrow: 1,
			backdropFilter: "blur(40px)",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			width: "100%"
		}}>
			<Box sx={{
				font: { xl: "700 64px/82px Lora-Bold", sm: "700 40px/51px Lora-Bold", xs: "700 24px/31px Lora-Bold" },
				color: "primary.main",
				textAlign: "center"
			}}>
				Congratulations!<br />
				Another mission is complete.
			</Box>

			<Confetti
				particleCount={250}
				particleSize={clientWidth <= 700 ? 10 : 15}
				force={0.8}
				duration={5000}
				width={clientWidth}
				colors={[
					"#C1D2EF",
					"#CAEAB1",
					"#E39BBE",
					"#7D84DA",
					"#E2E49D",
					"#9DDE8A",
					"#B5A7E7",
					"#96B8E2",
					"#DF8EA7",
					"#F6E0DB"
				]}
			/>

			<Box
				component="img"
				src={IMGCelebrationOcta}
				alt=""
				sx={{
					marginTop: { xl: "40px", sm: 0, xs: "80px" },
					maxWidth: { xl: "716px", sm: "602px", xs: "390px" },
					width: "100%"
				}}
			/>

			<Box sx={{
				margin: "0 auto",
				marginTop: { sm: "40px", xs: "auto" },
				width: { xs: "100%", sm: "unset" },
				minHeight: { sm: "unset", xs: "120px" }
			}}>

				<CustomButton.Contained
					size="large"
					onClick={onClickNextStep}
					loading={isLoading}
					sx={{
						maxWidth: "390px",
						width: { sm: "auto", xs: "100%" },
						boxShadow: "unset"
					}}
				>
					Continue
				</CustomButton.Contained>
			</Box>
		</Box>
	);
}

export default Complete;
